<template>
  <div class="student-tree">
    <div class="header">
      <div class="nav">
        <div class="list">
          <div
            class="nav-item"
            :class="[index < curTree.length - 1 ? 'active' : '']"
            :key="item.name"
            v-for="(item, index) in curTree"
            @click="navClick(index)"
          >
            <span class="text">{{ item.name }}</span>
            <van-icon name="arrow" v-if="index < curTree.length - 1" />
          </div>
        </div>
      </div>
    </div>
    <div class="body">
      <div class="list">
        <div
          class="item"
          :key="item.id"
          v-for="item in curTree[curTree.length - 1].child"
          @click="itemClick(item)"
        >
          <div
            class="left"
            v-if="checkType == 'multiple' || (item._isLeaf && item.userIndex)"
          >
            <van-radio
              name="2"
              :checked="
                item.checked === 'checked' || item.checked === 'halfChecked'
              "
              @click.stop="onClickRadio(item)"
            />
          </div>
          <div class="middle content">{{ item.name }}</div>
          <div class="right control" v-if="item.child && item.child.length">
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
    <div class="footer-tree-list">
      <van-button type="primary" round block @click="okEvt">确定</van-button>
    </div>
  </div>
</template>

<script>
import { ref, toRefs, watch } from "vue";
export default {
  name: "StudentTree",
  props: {
    type: {
      type: String,
      default: 'T'
    },
    checkType: {
      type: String,
      default: "multiple",
    },
    list: {
      type: Array,
      default() {
        return []
      }
    },
    defaultCheckedList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  setup(props, { emit }) {
    let { type, checkType, list, defaultCheckedList } = toRefs(props);
    const loopUpper = (parentRef) => {
      if (!parentRef) return;
      let child = parentRef.child;
      if (child && child.length) {
        let childListChecked = "halfChecked";
        if (child.every((item) => item.checked === "checked")) {
          childListChecked = "checked";
        }
        if (child.every((item) => item.checked === "unChecked")) {
          childListChecked = "unChecked";
        }
        parentRef.checked = childListChecked;
        loopUpper(parentRef.parentRef);
      }
    };

    // 状态标志 全选 checked 未选 unChecked 半选 halfChecked 添加父级引用及最后一级标志位
    const formatServeData = (list, checkedList) => {
      function loop(list, parentRef) {
        list.map((item) => {
          item.checked = "unChecked";
          item.parentRef = parentRef;
          if (checkedList.some((checkedItem) => checkedItem === item.userIndex)) {
            item.checked = "checked";
            loopUpper(item.parentRef);
          }

          if (item.child && item.child.length) {
            loop(item.child, item);
          }
          // if (item.studentMiniVos && item.studentMiniVos.length) {
          //   item.studentMiniVos.map((persionVos) => {
          //     if (persionVos.userIndex) {
          //       persionVos.id = persionVos.userIndex;
          //     }

          //     item.child.push(persionVos);
          //   });
          // }
          // if (item.child && item.child.length) {
          //   loop(item.child, item);
          // } else {
          //   item.isLastRef = true;
          // }
        });
      }
      loop(list, null);

      curTree.value = [];
      if (type.value == "S") {
        curTree.value.push({
          name: "学生列表",
          child: [...list],
        });
      } else {
        curTree.value.push({
          name: "教师列表",
          child: [...list],
        });
      }
    };

    // 初始化回显

    const curTree = ref([]);

    const navClick = (index) => {
      curTree.value = curTree.value.splice(0, index + 1);
    };

    const itemClick = (item) => {
      if (!item.child || !item.child.length) return;
      formatCurTree(item);
    };
    const formatCurTree = (item) => {
      let temp = {
        name: item.name,
        child: item.child,
      };
      curTree.value.push(temp);
    };

    watch(
      [list, defaultCheckedList],
      ([list, defaultCheckedList]) => {
        formatServeData(list, [...defaultCheckedList]);
      },
      {
        immediate: true,
      }
    );

    // 选择事件
    const onClickRadio = (item) => {
      if (checkType.value === "single") {
        clearCheckedAll(list.value, item._key);
      }
      if (item.checked === "unChecked" || item.checked === "halfChecked") {
        item.checked = "checked";
      } else {
        item.checked = "unChecked";
      }
      radioChangeWatch(item);
    };
    const clearCheckedAll = (list, key) => {
      function loop(list) {
        list.map((item) => {
          if (item && item._key !== key) {
            item.checked = "unChecked";
          }
          if (item.child && item.child.length) {
            loop(item.child, key);
          }
        });
      }
      loop(list, key);
    };
    const radioChangeWatch = (curItem) => {
      // 向上
      function loopUpper(parentRef) {
        if (!parentRef) return;
        let child = parentRef.child;
        if (child && child.length) {
          let childListChecked = "halfChecked";
          if (child.every((item) => item.checked === "checked")) {
            childListChecked = "checked";
          }
          if (child.every((item) => item.checked === "unChecked")) {
            childListChecked = "unChecked";
          }
          parentRef.checked = childListChecked;
          loopUpper(parentRef.parentRef);
        }
      }
      if (curItem.parentRef) {
        loopUpper(curItem.parentRef);
      }

      // 向下
      function loopDown(list, checked) {
        if (!list || !list.length) return;
        list.map((item) => {
          item.checked = checked;
          if (item.child && item.child.length) {
            loopDown(item.child, checked);
          }
        });
      }
      loopDown(curItem.child, curItem.checked);
    };

    const getCheckedList = () => {
      let checkedList = [];
      let list = curTree.value[0].child;

      function loop(list) {
        list.map((item) => {
          if (item.checked == "checked" && item.userIndex) {
            checkedList.push(item);
          }
          if (item.child && item.child.length) {
            loop(item.child);
          }
        });
      }
      loop(list);
      return checkedList;
    };

    const okEvt = () => {
      let checkedList = getCheckedList();
      emit("change", checkedList);
    };

    return {
      curTree,
      navClick,
      itemClick,
      onClickRadio,
      okEvt,
    };
  },
};
</script>

<style lang="less" scoped>
.student-tree {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #333;
  font-size: 15px;
  font-weight: 400;
  background-color: #f2f4f9;
}
.header {
  box-sizing: border-box;
  background-color: #fff;
  .nav {
    box-sizing: border-box;
    width: 100vw;
    height: 54px;
    line-height: 54px;
    overflow-x: auto;
    .list {
      white-space: nowrap;
      .nav-item {
        display: inline-block;
        &.active {
          color: #4275fd;
        }
        .text {
          margin: 0 12px;
        }
      }
    }
  }
}
.body {
  box-sizing: border-box;
  flex: 1;
  // padding: 0 15px;
  margin-top: 10px;
  overflow-y: auto;
  .list {
    padding: 0 15px;
    background-color: #fff;
    .item {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 54px;
      .left {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        margin-right: 10px;
      }
      .middle {
        box-sizing: border-box;
        flex: 1;
        display: flex;
        align-items: center;
        height: 100%;
        border-bottom: 1px solid #e5e5e5;
      }
      .right {
        flex: 0;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        height: 100%;
        border-bottom: 1px solid #e5e5e5;
      }
    }
  }
}
.footer-tree-list {
  box-sizing: border-box;
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 6px 15px;
  border-top: 1px solid #e5e5e5;
  background-color: #fff;
}
</style>
